var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasAnyPratica
      ? _c(
          "div",
          [
            _c(
              "el-collapse",
              { on: { change: function() {} } },
              [
                _vm.praticas.praticaSustentavelPRPD
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title:
                            "Práticas para Recuperação de Pastagens Degradadas (PRPD)",
                          name: "PRPD"
                        }
                      },
                      [
                        _c("PRPD", {
                          attrs: {
                            pratica: _vm.praticas.praticaSustentavelPRPD
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.praticas.praticaSustentavelSPDG &&
                _vm.praticas.praticaSustentavelSPDG.length
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: "Sistema de Plantio Direto de Grãos (SPDG)",
                          name: "SPDG"
                        }
                      },
                      [
                        _c("SPDG", {
                          attrs: {
                            praticas: _vm.praticas.praticaSustentavelSPDG
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.praticas.praticaSustentavelSPDH &&
                _vm.praticas.praticaSustentavelSPDH.length
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title:
                            "Sistema de Plantio Direto de Hortaliças (SPDH)",
                          name: "SPDH"
                        }
                      },
                      [
                        _c("SPDH", {
                          attrs: {
                            praticas: _vm.praticas.praticaSustentavelSPDH
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.praticas.praticaSustentavelILPF
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: "Integração Lavoura-Pecuária-Floresta (ILPF)",
                          name: "ILPF"
                        }
                      },
                      [
                        _c("ILPF", {
                          attrs: {
                            pratica: _vm.praticas.praticaSustentavelILPF
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.praticas.praticaSustentavelSAF
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: "Sistemas Agroflorestais (SAF)",
                          name: "SAF"
                        }
                      },
                      [
                        _c("SAF", {
                          attrs: { pratica: _vm.praticas.praticaSustentavelSAF }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.praticas.praticaSustentavelFP
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: { title: "Florestas Plantadas (FP)", name: "FP" }
                      },
                      [
                        _c("FP", {
                          attrs: { pratica: _vm.praticas.praticaSustentavelFP }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.praticas.praticaSustentavelMRPA
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: "Manejo de Resíduos da Produção Animal (MRPA)",
                          name: "MRPA"
                        }
                      },
                      [
                        _c("MRPA", {
                          attrs: {
                            pratica: _vm.praticas.praticaSustentavelMRPA
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.praticas.praticaSustentavelTI
                  ? _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: "Terminação intensiva (TI)",
                          name: "TI"
                        }
                      },
                      [
                        _c("TI", {
                          attrs: { pratica: _vm.praticas.praticaSustentavelTI }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      : _c("div", [_c("span", [_vm._v("Nenhuma prática exercida.")])])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cdc1623", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdc1623","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/Praticas.vue
// module id = null
// module chunks = 